import React from 'react';
import { LegalShell } from './PrivacyPolicy';
import { CONTACT } from '../data/siteData';
import { useSEO } from '../hooks/useSEO';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-semibold text-[#0A192F] font-heading mb-3">{title}</h2>
    <div className="text-sm text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Terms() {
  useSEO('Terms & Conditions | WorkLynx');
  return (
    <LegalShell title="Terms & Conditions" updated="June 2026">
      <Section title="1. Acceptance of Terms">
        <p>By accessing worklynx.co.in or engaging WorkLynx services, you agree to these Terms &amp; Conditions. If you do not agree, please discontinue use of the website.</p>
      </Section>
      <Section title="2. Services">
        <p>WorkLynx provides workforce deployment, AI data collection, robotics operations support, IT and Non-IT hiring, BPO solutions and managed workforce services. Specific engagements are governed by individually executed service agreements and statements of work.</p>
      </Section>
      <Section title="3. Use of Website">
        <p>You agree to use this website for lawful purposes only and not to submit false, misleading or malicious information through our forms.</p>
      </Section>
      <Section title="4. Intellectual Property">
        <p>All content on this website — including text, branding, graphics and layout — is the property of WorkLynx and may not be reproduced without written permission.</p>
      </Section>
      <Section title="5. Limitation of Liability">
        <p>Website content is provided for general information. WorkLynx shall not be liable for indirect or consequential damages arising from use of this website. Contractual liabilities are defined in individual service agreements.</p>
      </Section>
      <Section title="6. Governing Law">
        <p>These terms are governed by the laws of India, with courts in New Delhi having exclusive jurisdiction.</p>
      </Section>
      <Section title="7. Contact">
        <p>Questions about these terms? Write to {CONTACT.email} or call {CONTACT.phone}.</p>
      </Section>
    </LegalShell>
  );
}
